module.exports = __webpack_public_path__ + "img/yx1-zh.d4b9bb5b.jpg";